<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import Window from "../components/Window.svelte";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog, addWarn } from "../stores/LoggerStore";
  import { FileMgr } from "../stores/FileMgr";
  import Path from "../scripts/Path";
  import { get, writable } from "svelte/store";
  import ProcMgr from "../stores/ProcMgr";
  import SettingsMgr from "../stores/SettingsMgr";

  export let winProps: WinProps;
  let textFilePath: string = winProps.data?.path || "";
  let textAreaElem: HTMLElement,
    textAreaValue,
    alertElem: HTMLElement,
    alertContent: string;
  const thememgr = SettingsMgr.getInstance();
  let _theme = thememgr.theme;
  const themeWatcher = (theme: Theme) => {
    const c = theme.colors;
    if (!textAreaElem) {
      return;
    }
    textAreaElem.style.setProperty("color", c["1"]);
    textAreaElem.style.setProperty("background-color", c["2"]);

    return c;
  };
  $: _colors = themeWatcher($_theme);

  const activateAlert = (msg: string) => {
    alertContent = msg;
    alertElem.classList.add("active");
    setTimeout(() => {
      if (alertElem) {
        alertElem.classList.remove("active");
      }
    }, 3500);
  };

  const callbacks: WinCbs = {
    onFocus: () => {
      addLog("Notepad focus callback");
      textAreaElem.focus();
      return true;
    },
    confirmClose: () => {
      addLog("Confirm close?");
      return true;
      // return false;
    },
  };
  const filemgr = FileMgr.getInstance();

  const loadFile = (e) => {
    textAreaValue = _loadTextFile(textFilePath) || "";
    loadWindowName(textFilePath);
    activateAlert(`File loaded : ${textFilePath}`);
  };

  const saveFile = (e) => {
    const f = filemgr.findFile(new Path(textFilePath));
    if (!f) {
      activateAlert(`Failed to Save : ${textFilePath}`);
      return;
    }
    if (!f.data) {
      f.data = {};
    }
    (f.data as any).text = textAreaValue;
    filemgr.updateFile(f);
    activateAlert(`File Saved : ${textFilePath}`);
  };

  const _loadTextFile = (path: string) => {
    if (!path || !path.length) {
      return;
    }
    const file = filemgr.findFile(new Path(path));
    if (!file) {
      addWarn("Notepad opened without file basis");
      return;
    }
    return (file.data as any)?.text;
  };

  const loadWindowName = (path: string) => {
    winProps.name = `Notepad${
      path.length > 0 ? " - " + new Path(path).last : ""
    }`;
  };
  loadWindowName(textFilePath);

  let _text = writable(textAreaValue);
  const updateValue = (e) => {
    _text.set(textAreaValue);
  };
  const procmgr = ProcMgr.getInstance();
  procmgr.setWinDataFecther(winProps.id, "text", () => _text);

  onMount(() => {
    _colors = themeWatcher($_theme);
    textFilePath = winProps.data?.path || new Path("");
    textAreaValue = _loadTextFile(textFilePath) || winProps.data?.text || "";
    _text.set(textAreaValue);
  });
  onDestroy(() => {});
</script>

<Window {winProps} {callbacks}>
  <div class="container">
    <div class="btns">
      <button title="Reload" class="btn reload" on:click={loadFile}
        >&#8634;</button
      >
      <button title="Save" class="btn save" on:click={saveFile}>&darr;</button>
    </div>
    <div
      class="notepad-alert"
      bind:this={alertElem}
      on:click={() => {
        alertElem.classList.remove("active");
      }}
    >
      {alertContent}
    </div>
    <textarea
      spellcheck="false"
      class="text-area"
      bind:this={textAreaElem}
      bind:value={textAreaValue}
      on:input={updateValue}
    />
  </div>
</Window>
<div class="css-keeper notepad-alert active" />

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .btns {
    position: absolute;
    width: 80px;
    height: 30px;
    top: 0;
    right: 0;
    display: flex;
  }
  .btn {
    flex: 1;
    margin: 0;
    padding: 0;
    border: none;
    box-shadow: 0px 0px 2px #333;
    transition: 0.1s;
  }
  .btn:hover {
    box-shadow: 1px 1px 3px #333;
    color: black;
    font-size: 1.3rem;
    transform: translate(-2px, -2px);
  }
  .btn:active {
    box-shadow: 0px 0px 0px;
    background-color: #666;
    transform: translate(0px, 0px);
  }

  .notepad-alert {
    /* display: none; */
    display: block;
    opacity: 0;
    position: absolute;
    right: 0;
    padding: 10px;
    /* width: 40%; */
    bottom: 0;
    height: 22px;

    transition: 0.2s;
    transform: translateY(42px);
    background-color: transparent;
    color: transparent;
    border-top-left-radius: 11px;
    cursor: pointer;
  }
  .notepad-alert.active {
    opacity: 1;
    transform: translateY(0px);
    background-color: #dbdbdb;
    color: #333;
  }

  .text-area {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 3px;
    resize: none;
    border: none;
    border-radius: 0;
    outline-color: transparent;
    box-sizing: border-box;
  }
  .text-area:visible,
  .text-area:focus-visible {
    outline: none;
  }
  .css-keeper.notepad-alert {
    display: none;
  }
</style>
